/**
 * CMMS Permission Constants
 * Must match the CmmsPermission enum in the backend
 */
export const PERMISSIONS = {
  // Dashboard
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',

  // Assets
  VIEW_ASSETS: 'VIEW_ASSETS',
  CREATE_ASSETS: 'CREATE_ASSETS',
  EDIT_ASSETS: 'EDIT_ASSETS',
  DELETE_ASSETS: 'DELETE_ASSETS',

  // Work Orders
  VIEW_WORK_ORDERS: 'VIEW_WORK_ORDERS',
  VIEW_ALL_WORK_ORDERS: 'VIEW_ALL_WORK_ORDERS',
  CREATE_WORK_ORDERS: 'CREATE_WORK_ORDERS',
  EDIT_WORK_ORDERS: 'EDIT_WORK_ORDERS',
  DELETE_WORK_ORDERS: 'DELETE_WORK_ORDERS',
  ASSIGN_WORK_ORDERS: 'ASSIGN_WORK_ORDERS',
  COMPLETE_WORK_ORDERS: 'COMPLETE_WORK_ORDERS',

  // Branches & Locations
  VIEW_BRANCHES: 'VIEW_BRANCHES',
  CREATE_BRANCHES: 'CREATE_BRANCHES',
  EDIT_BRANCHES: 'EDIT_BRANCHES',
  DELETE_BRANCHES: 'DELETE_BRANCHES',
  VIEW_LOCATIONS: 'VIEW_LOCATIONS',
  CREATE_LOCATIONS: 'CREATE_LOCATIONS',
  EDIT_LOCATIONS: 'EDIT_LOCATIONS',
  DELETE_LOCATIONS: 'DELETE_LOCATIONS',

  // Contracts & Suppliers
  VIEW_CONTRACTS: 'VIEW_CONTRACTS',
  CREATE_CONTRACTS: 'CREATE_CONTRACTS',
  EDIT_CONTRACTS: 'EDIT_CONTRACTS',
  DELETE_CONTRACTS: 'DELETE_CONTRACTS',
  VIEW_SUPPLIERS: 'VIEW_SUPPLIERS',
  CREATE_SUPPLIERS: 'CREATE_SUPPLIERS',
  EDIT_SUPPLIERS: 'EDIT_SUPPLIERS',
  DELETE_SUPPLIERS: 'DELETE_SUPPLIERS',

  // PM Schedules
  VIEW_PM_SCHEDULES: 'VIEW_PM_SCHEDULES',
  CREATE_PM_SCHEDULES: 'CREATE_PM_SCHEDULES',
  EDIT_PM_SCHEDULES: 'EDIT_PM_SCHEDULES',
  DELETE_PM_SCHEDULES: 'DELETE_PM_SCHEDULES',
  EXECUTE_PM_SCHEDULES: 'EXECUTE_PM_SCHEDULES',

  // Team Management
  VIEW_TEAM: 'VIEW_TEAM',
  CREATE_TEAM_MEMBERS: 'CREATE_TEAM_MEMBERS',
  EDIT_TEAM_MEMBERS: 'EDIT_TEAM_MEMBERS',
  DELETE_TEAM_MEMBERS: 'DELETE_TEAM_MEMBERS',

  // Reports
  VIEW_REPORTS: 'VIEW_REPORTS',
  EXPORT_REPORTS: 'EXPORT_REPORTS',

  // Settings
  MANAGE_SETTINGS: 'MANAGE_SETTINGS',

  // Access all branches (bypass branch filter)
  ACCESS_ALL_BRANCHES: 'ACCESS_ALL_BRANCHES',
};

/**
 * Map menu items to required permissions
 */
export const MENU_PERMISSIONS = {
  // Main Dashboard
  'Dashboard': [PERMISSIONS.VIEW_DASHBOARD],

  // CMMS Sub-menus
  'Overview': [PERMISSIONS.VIEW_DASHBOARD],
  'Assets': [PERMISSIONS.VIEW_ASSETS],
  'Work Orders': [PERMISSIONS.VIEW_WORK_ORDERS],
  'Branches': [PERMISSIONS.VIEW_BRANCHES],
  'Locations': [PERMISSIONS.VIEW_LOCATIONS],
  'Contracts': [PERMISSIONS.VIEW_CONTRACTS],
  'Suppliers': [PERMISSIONS.VIEW_SUPPLIERS],
  'PM Schedules': [PERMISSIONS.VIEW_PM_SCHEDULES],
  'Team': [PERMISSIONS.VIEW_TEAM],
  'Reports': [PERMISSIONS.VIEW_REPORTS],
  'Inventory': [PERMISSIONS.VIEW_ASSETS], // Uses asset permission
  'Maintenance': [PERMISSIONS.VIEW_PM_SCHEDULES],

  // Admin-only menus
  'Products': [PERMISSIONS.MANAGE_SETTINGS],
  'Billing': [PERMISSIONS.MANAGE_SETTINGS],
  'Activity Log': [PERMISSIONS.MANAGE_SETTINGS],
};

/**
 * CMMS User Roles
 */
export const CMMS_ROLES = {
  CMMS_ADMIN: 'CMMS_ADMIN',
  MANAGER: 'MANAGER',
  SUPERVISOR: 'SUPERVISOR',
  TECHNICIAN: 'TECHNICIAN',
  VIEWER: 'VIEWER',
};

/**
 * Role display labels
 */
export const ROLE_LABELS = {
  [CMMS_ROLES.CMMS_ADMIN]: 'Admin',
  [CMMS_ROLES.MANAGER]: 'Manager',
  [CMMS_ROLES.SUPERVISOR]: 'Supervisor',
  [CMMS_ROLES.TECHNICIAN]: 'Technician',
  [CMMS_ROLES.VIEWER]: 'Viewer',
};
